import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Circle } from "lucide-react";
import { Link } from "react-router-dom";
import Category from "../text/Category";

type FileSumProps = {
  uid?: string;
  name?: string;
  wording?: string;
  status?: string;
  stageFile?: string;
  stateFile?: string;
  live?: boolean;
  stageType?: string;
  stateType?: string;
  code?: string;
};

const FileSumContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 14px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 15px;
  border: 1px solid var(--Main-stroke-1, #ebebeb);
  background: #fff;
  box-sizing: border-box;
`;

const Titles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  align-self: stretch;
`;

const Tags = styled.div`
  display: flex;
  padding: 10px 0px;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const LiveIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #fff2f2;
  border: 1px solid #ff6b6b;
`;

const LiveText = styled.span`
  color: #e74c3c;
  font-family: "Sharp Sans";
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const Title = styled(Link)`
  color: #232129;
  font-family: "Sharp Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
  display: block;
`;

const Description = styled.span`
  color: #232129;
  font-family: "Sharp Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const Options = styled.button`
  width: fit-content;
  height: fit-content;
  cursor: pointer;
  border: none;
  padding: 0;
  background: none;
`;

const FileSum: React.FC<FileSumProps> = ({
  uid,
  name,
  wording,
  status,
  stageFile,
  stateFile,
  live,
  code,
  stageType,
  stateType,
}) => {
  const items = [{ label: "Suivre", value: "follow", available: false }];
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
  const [chamber, setChamber] = useState("");

  useEffect(() => {
    if (code?.includes("SN")) {
      setChamber("Senat");
    } else if (code?.includes("AN")) {
      setChamber("Assemblée Nationale");
    }
  }, [code]);

  return (
    <FileSumContainer>
      <Titles>
        <TitleContainer>
          <Title key={uid} to={`/file/${uid}/overview`}>
            {name}
          </Title>
          {/*
          {live && (
            
            <LiveIndicator>
              <Circle size={8} fill="#e74c3c" color="#e74c3c" />
             <LiveText>En cours</LiveText>
            </LiveIndicator>
          )}*/}
        </TitleContainer>
        <Description>{wording}</Description>
      </Titles>
      <Tags>
        <Category type={"chamber"}>{chamber}</Category>
        <Category type={"step"}>{stageFile}</Category>
        <Category type={"step"}>{stateFile}</Category>
      </Tags>
    </FileSumContainer>
  );
};

export default FileSum;
